module.exports = __webpack_public_path__ + "static/media/kimMarkGail.37ce1fac.png";